import { isOnServer } from "@origin-digital/tal-common";

export function shouldInitialize(): boolean {
  // Do not initialise client-only features during SSR. tal-core runs the bundle with a fake
  // JSDOM window and sets window.oetal.ssr.onServer = true; without this check we could
  // still pass the pathname check below and trigger code that fetches (e.g. Survicate, logger).
  if (isOnServer()) {
    return false;
  }

  const platformApps = [
    "/auth/callback",
    "/logout",
    "/auth/ml",
    "/auth/sml",
    "/my-account/contexthub",
  ];

  // Use globalThis so that there isn't a undeclared "window" variable in a node context (SSR)
  const pathName = globalThis?.window?.location?.pathname;
  if (!pathName) {
    return false;
  }

  const isPlatformApp = platformApps.some((app) => app === pathName);

  // Do not initialise for platform specific and kraken apps
  if (isPlatformApp) {
    return false;
  }

  return true;
}
